<template>
	<v-card class="background darken-1">
		<DropFileZone
			v-model="file"
			@droppedFiles="onFileDrop($event)">
		</DropFileZone>
		<v-card-title class="py-2 elevation-4">
			<slot name="card-title"></slot>
		</v-card-title>
		<v-card-title class="pa-0 elevation-4" style="background-color: #00001933">
			<v-btn flat small block color="primary" class="ma-0 text-none" @click="addRow()">
				<v-icon class="mr-2">add</v-icon>
				Ajouter une ligne de job
			</v-btn>
		</v-card-title>
		<v-card-text class="pa-0 form">
			<table v-if="sheet_data_head.length > 0">
				<colgroup>
					<col style="width: 32px" />
					<col
						v-for="(header, indexHead) in sheet_data_head"
						:key="'headerCol' + indexHead"
						style="width: auto" />
					<col style="width: 32px" />
				</colgroup>
				<thead>
					<tr>
						<th>
							<v-btn
								small icon flat
								class="ma-0"
								:disabled="sheet_data.length === 0"
								@click="sheet_data = []">
								<v-icon small>close</v-icon>
							</v-btn>
						</th>
						<th v-for="(header, indexHead) in sheet_data_head"
							:key="'header' + indexHead">
							<span class="subheading pl-2">
								{{ header | spacedTitleCase }}
							</span>
						</th>
						<th></th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item, indexItem) in sheet_data"
						:key="'item' + indexItem"
						:class="{
							'success--text': item.meta.valid ,
							'error--text': !item.meta.valid ,
							'warning--text': item.meta.warning
						}">
						<td>
							<v-btn
								small icon flat
								class="ma-0"
								@click="sheet_data.splice(indexItem, 1)">
								<v-icon small>close</v-icon>
							</v-btn>
						</td>
						<td v-for="(key, indexKey) in Object.keys(item.params)"
							:key="'key' + indexKey">
							<span class="cell-chip">
								{{ item.cells[key] }}
							</span>
							{{ item.params[key] }}
						</td>
						<td class="align-middle">
							<v-icon
								v-if="item.meta.submitted"
								size="23"
								color="success"
								class="ma-0 pa-0">
								sentiment_satisfied
							</v-icon>
							<v-tooltip v-if="!item.meta.valid" bottom color="error">
								<v-icon
									slot="activator"
									size="23"
									color="error"
									class="ma-0 pa-0">
									error
								</v-icon>
								<span>
									<ul class="mb-0">
										<li
											v-for="(message, index) in item.meta.messages"
											:key="'message' + index">
											{{ message }}
										</li>
									</ul>
								</span>
							</v-tooltip>
						</td>
					</tr>
				</tbody>
			</table>
			<div id="batch-table">
			</div>
			<!-- <div id="batch-table-footer" class="tabulator-footer">
				<v-btn class="ma-0" small flat icon color="primary" @click="addRow()">
					<v-icon>add</v-icon>
				</v-btn>
			</div> -->
		</v-card-text>

		<v-card-actions class="elevation-4">
			<!-- <v-btn flat icon color="primary" @click="addRow()">
				<v-icon>add</v-icon>
			</v-btn> -->
			<v-btn
				flat
				color="primary"
				class="text-none"
				@click="downloadTemplate()">
				<v-icon class="mr-1">file_download</v-icon>
				Template XLSX
			</v-btn>
			<v-spacer></v-spacer>
			<v-btn
				v-if="follow_jr"
				flat
				color="yellow accent-3"
				class="text-none"
				@click="follow_jr = !follow_jr">
				<v-icon class="mr-1">star</v-icon>
				Suivre les jobs
			</v-btn>
			<v-btn
				v-else
				flat
				color="background lighten-5"
				class="text-none"
				@click="follow_jr = !follow_jr">
				<v-icon class="mr-1">star_outline</v-icon>
				Suivre les jobs
			</v-btn>
			<v-btn
				color="primary color--text"
				class="text-none"
				:loading="submitting"
				:disabled="this.batch_count === 0"
				@click="launchBatch()">
				<v-icon class="mr-2" large>play_arrow</v-icon>
				Démarrer le batch
				<v-chip small color="color primary--text" class="ml-2" v-if="batch_count">
					{{ batch_count }} jobs
				</v-chip>
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
import DropFileZone from '@/components/drop_file_zone.vue'
import BatchJs from '@/pages/maestro/launcher/launcher_xlsx.js'
import Tabulator from 'tabulator-tables'
import 'tabulator-tables/dist/css/tabulator_midnight.min.css'
export default {
	props: [ 'jd', 'last_version_number', 'jds', 'unitary_to_batch_data' ],
	components: { DropFileZone },
	data () {
		return {
			nb_lines: 10,
			file: null,
			submitting: false,
			progress: 0,
			ext_handled: ['.XLSX', '.XLS'],
			sheet_data: [],
			sheet_data_head: [],
			params: [],
			filename: null,
			follow_jr: false,
			errors: [],
			warnings: [],
			batch_table: null,
			batch_data: null,
			batch_count: 0,
			success: ''
		}
	},
	methods: {
		downloadTemplate () {
			BatchJs.download_xlsx(this.jd, this.last_version_number)
		},
		addRow () {
			let line = { _submitted: false, _error: '' }
			let tableData = this.batch_table.getData()
			let lastLine = tableData[tableData.length - 1]
			if (lastLine) line = { ...lastLine, ...line }
			this.batch_table.addRow(line)
		},
		onFileDrop (files) {
			this.$emit('modal-width', '1080px')
			this.errors = []
			this.warnings = []
			this.success = ''
			this.submitting = false
			this.sheet_data = []
			this.sheet_data_head = []
			this.selected_rows = []
			this.params = []
			this.filename = null
			if (!files) return
			if (files.length !== 1) return

			let file = files[0]

			let ext = file.name.substring(file.name.lastIndexOf('.'))
			if (this.ext_handled.indexOf(ext.toUpperCase()) === -1) {
				this.errors.push('Seulement les fichiers .XLSX or .XLS ne sont gérés')
				return
			}

			let basename = file.name.substring(0, file.name.lastIndexOf('.'))
			if (!basename) {
				this.errors.push('Impossible de determiner le nom du fichier de batch')
				return
			}

			this.filename = file.name

			let basenameArr = basename.split('_')
			let workflowIdSection = basenameArr[2]
			let workflowVersionSection = basenameArr[3]
			let workflowLastSection = basenameArr[4]
			let workflowId = null
			if (workflowIdSection) {
				workflowId = parseInt(workflowIdSection.split('-')[1])
			}
			if (!workflowId) {
				this.errors.push('Impossible de determiner l\'id du workflow')
				return
			}

			let workflowVersion = null
			if (!workflowLastSection && workflowVersionSection) {
				workflowVersion = parseInt(workflowVersionSection.split('-')[1], 10)
			} else if (workflowLastSection.indexOf('LAST') > -1) {
				workflowVersion = 'LAST'
			} else {
				this.errors.push('Impossible de determiner la version du workflow')
				return
			}

			for (let i = 0; i < this.jds.length; i++) {
				if (this.jds[i].id === workflowId) {
					this.$emit('change-jd', this.jds[i])
					break
				}
			}
			this.$EsMaestro.jobdescriptor_read(workflowId)
				.then(result => {
					this.$emit('change-jd-versions', result)
					if (workflowVersion === 'LAST') {
						this.$emit('change-jd-version', result[0])
						this.params = result[0].parameters
					} else {
						for (let i = 0; i < result.length; i++) {
							if (result[i].version_number === workflowVersion) {
								this.$emit('change-jd-version', result[i])
								this.params = result[i].parameters
								break
							}
						}
					}
					if (this.params.length === 0) {
						throw new Error('Impossible de retrouver les paramètres du workflow')
					}
					// return BatchJs.read_xlsx(file, this.params)
					return BatchJs.xlsx_to_tabulator(file, this.params)
				})
				.then(result => {
					// this.warnings = result.warnings
					// this.errors = result.errors
					// this.sheet_data = result.sheetData
					// this.sheet_data_head = result.sheetDataHead
					// if (this.sheet_data_head.length > 0) {
					// 	let width = 150 * (this.sheet_data_head.length) + 20
					// 	if (width < 1080) width = 1080
					// 	if (width > window.outerWidth) width = window.outerWidth
					// 	this.$emit('modal-width', width + 'px')
					// }
					this.batch_data = result.data
					this.batch_table.setColumns(result.columns)
					return this.batch_table.replaceData(this.batch_data)
					// let batchTable = new Tabulator('#batch-table', {
					// 	height: '60vh',
					// 	validationMode: 'highlight',
					// 	data: this.batch_data,
					// 	reactiveData: true,
					// 	layout: 'fitColumns',
					// 	columns: result.columns
					// })
					// this.batch_table = batchTable
				})
				.then(() => {
					this.resizeDialog()
				})
				.catch(error => {
					console.error(error)
					this.errors.push(error.message)
				})
		},
		resizeDialog () {
			let tableWidth = this.batch_table.columnManager.getWidth()
			let modalWidth = 1080
			if (tableWidth > modalWidth) {
				modalWidth = tableWidth
			}
			if (tableWidth > window.outerWidth) {
				modalWidth = window.outerWidth
			}
			this.$emit('modal-width', modalWidth + 'px')
		},
		launchJobFake () {
			return new Promise((resolve, reject) => {
				setTimeout(() => {
					let random = Math.random()
					if (random > 0.5) {
						resolve(random * 1e17.toString())
					} else {
						reject(new Error('Erreur Random'))
					}
				}, 1000)
			})
		},
		launchJob (parameters) {
			return new Promise((resolve, reject) => {
				let data = {
					jd_id: this.jd.descriptor_id,
					jd_version: this.jd.version_number,
					parameters: parameters
				}
				this.$ApiMaestro.jobrequest_create(data)
					.then(response => {
						if (response.data.created) {
							resolve(response.data.created)
						} else {
							throw new Error('Error during submiting job')
						}
					})
					.catch(error => {
						if (error.response) {
							let newError = error.response.statusText
							Object.keys(error.response.data).map(key => {
								error.response.data[key].map(err => {
									newError += ' '
									newError += err
								})
							})
							reject(new Error(newError))
						} else {
							reject(error)
						}
					})
			})
		},
		// async launchBatch () {
		// 	for (const job of this.sheet_data) {
		// 		try {
		// 			let submitted = await this.launchJobFake()
		// 			job.meta.submitted = submitted
		// 		} catch (error) {
		// 			job.meta.warning = true
		// 			job.meta.messages.push(error.message)
		// 		}
		// 		console.log(job)
		// 	}
		// }
		async launchBatch () {
			this.submitting = true
			let rows = this.batch_table.getRows()
			let jr_submitted = []
			let jr_errored = []
			for (const row of rows) {
				let rowIsToLaunch = true
				let rowData = row.getData()
				if (rowData._submitted) {
					rowIsToLaunch = false
				} else {
					for (const cell of row.getCells()) {
						if (!cell.isValid()) {
							rowIsToLaunch = false
							break
						}
					}
				}
				if (rowIsToLaunch) {
					let parameters = {}
					for (const key in rowData) {
						if (key[0] !== '_') parameters[key] = rowData[key]
					}
					try {
						// let jrID = await this.launchJobFake()
						let jrID = await this.launchJob(parameters)
						this.batch_table.scrollToRow(row, 'top', false)
						if (this.follow_jr) {
							setTimeout(() => {
								this.$Bus.$emit('follow-jrs', [jrID])
							}, 2000)
						}
						jr_submitted.push(jrID)
						row.update({ _submitted: true })
						row.reformat()
					} catch (error) {
						jr_errored.push(error.message)
						row.update({ _error: error.message })
						row.reformat()
					}
				}
			}
			rows = this.batch_table.getRows()
			for (const row of rows) {
				if (row.getData()._submitted) {
					row.delete()
				}
			}
			this.submitting = false
			if (jr_submitted.length > 0 || jr_errored.length > 0) {
				let status = jr_submitted.length > 0 ? 'success' : 'error'
				let title = `${jr_submitted.length} Jobs lancés avec succès`
				let message = jr_submitted
				if (jr_submitted.length === 0 && jr_errored.length > 0) {
					title = `${jr_errored.length} Jobs en échec de lancement`
					message = jr_errored
				}
				if (jr_errored.length > 0) {
					message.push('')
					message.push(`Attention ${jr_errored.length} `)
					if (jr_errored.length === 1) {
						message.push('job n\'a pu être lancé')
					} else {
						message.push(`jobs n'ont pu être lancés`)
					}
					message.push(...jr_errored)
				}
				this.$EventDialer(status, false, title, message, 0)
			}
		},
		handlePaste (evt) {
			let text = (evt.clipboardData || window.clipboardData).getData('text')
			let pastedData = text
				.split('\n')
				.filter(line => line)
				.map(line => line.split('\t'))

			let names = pastedData[0].join('|')
			let parametersNames = this.jd.parameters.map(p => p.name).join('|')

			if (names.localeCompare(parametersNames) === 1) {
				for (let i = 1; i < pastedData.length; i++) {
					let line = { _submitted: false, _error: '' }
					for (let j = 0; j < pastedData[0].length; j++) {
						line[pastedData[0][j]] = pastedData[i][j]
					}
					this.batch_table.addRow(line)
				}
			}
		}
	},
	mounted () {
		document.addEventListener('paste', this.handlePaste)
		this.params = this.jd.parameters
		BatchJs.xlsx_to_tabulator(null, this.params, this.unitary_to_batch_data)
			.then(result => {
				this.$emit('unitary-data-loaded')
				this.batch_data = result.data
				let batchTable = new Tabulator('#batch-table', {
					// height: 'calc(100% - 28px)',
					height: '100%',
					tabEndNewRow: { _submitted: false },
					columnHeaderVertAlign: 'bottom',
					validationMode: 'highlight',
					data: this.batch_data,
					reactiveData: true,
					layout: 'fitColumns',
					columns: result.columns,
					// footerElement: '#batch-table-footer',
					dataLoaded: (data) => { this.batch_count = data.length },
					dataChanged: (data) => { this.batch_count = data.length },
					rowFormatter: (row) => {
						let rowData = row.getData()
						if (rowData._submitted) {
							row.getElement().style.color = '#00E676'
						}
						if (rowData._error) {
							row.getElement().style.color = 'var(--v-error-base)'
						}
					}
				})
				this.batch_table = batchTable
				this.resizeDialog()
			})
			.catch(error => {
				console.error(error)
				this.errors.push(error.message)
			})
	},
	beforeDestroy () {
		document.removeEventListener('paste', this.handlePaste)
	}
}
</script>

<style lang="stylus" scoped>
table
	width: 100%
	tr
		border-bottom: 1px solid var(--v-background-darken4)
	thead
		tr
			box-shadow: 0 2px 4px -1px rgba(0, 0, 0, .2) inset, 0 4px 5px 0 rgba(0, 0, 0, .14) inset, 0 1px 10px 0 rgba(0, 0, 0, .12) inset !important
			position: sticky
			top: 0
			background-color: var(--v-background-darken2)
			z-index: 1
			th
				padding: 4px 2px
	td
		padding: 4px 2px
		vertical-align: middle
		.cell-chip
			display: inline-block
			width: 32px !important
			height: 24px !important
			align-content: center
			margin-right: 4px
			text-align: center
			font-size: 10px
			outline: 1px solid var(--v-background-darken4)
			background-color: rgba(0, 0, 20, 0.25)
		.v-icon
			cursor: pointer

.form
	border-top: 0.5px solid var(--v-background-base)
	border-bottom: 0.5px solid var(--v-background-base)

.tabulator
	border: none
	background-color: var(--v-background-darken1)
	border-color: var(--v-background-base)
	>>>.v-icon
		color: inherit
	>>>.tabulator-header
		background-color: var(--v-background-darken1)
		border: none
		.tabulator-col
			box-shadow: 0 2px 4px -1px rgba(0, 0, 0, .2) inset, 0 4px 5px 0 rgba(0, 0, 0, .14) inset, 0 1px 10px 0 rgba(0, 0, 0, .12) inset !important
			background-color: rgba(0, 0, 25, 0.2)
			border-color: var(--v-background-base)
			font-size: 16px
			font-weight: normal
			color: var(--v-background-lighten5)
			.tabulator-col-content
				padding: 6px 4px
		.tabulator-col-group-cols
			border-color: var(--v-background-base) !important
	>>>.tabulator-table
		background-color: var(--v-background-darken1)
		.tabulator-row-odd
			background-color: var(--v-background-base)
			.tabulator-cell
				border-color: var(--v-background-darken1)
			.tabulator-validation-fail
				background-color: var(--v-error-base)
				border-color: transparent
				caret-color: white !important
				*
					color: white !important
		.tabulator-row-even
			background-color: var(--v-background-darken1)
			.tabulator-cell
				border-color: var(--v-background-base)
			.tabulator-validation-fail
				background-color: var(--v-error-darken1)
				border-color: transparent
				caret-color: white !important
				*
					color: white !important
		.tabulator-editing
			border-color: var(--v-primary-base) !important
</style>



// WEBPACK FOOTER //
// src/pages/maestro/launcher/launcher_batch.vue